import { Dropdown } from '~/design-system/components/Dropdown/Dropdown';
import { Button } from '~/design-system/elements/Button/Button';

export interface FileUploadButtonUIProps {
  isActive?: boolean;
  onAddImagesClick?: () => void;
  onAttachFilesClick?: () => void;
  /** Grey out "Attach files" where documents have nowhere to go — slide/artifact generation takes
   *  pictures but has no channel for a document yet. Defaults to enabled, so chat is unaffected. */
  attachFilesDisabled?: boolean;
  /** The one-line reason shown under a disabled "Attach files". */
  attachFilesCaption?: string;
}

export const FileUploadButtonUI = ({
  isActive = false,
  onAddImagesClick,
  onAttachFilesClick,
  attachFilesDisabled = false,
  attachFilesCaption,
}: FileUploadButtonUIProps) => (
  <Dropdown
    trigger={(
      <Button
        type="button"
        variant="ghostMuted"
        size="icon-xs"
        aria-label="Add attachments"
        leadIcon="add"
        data-active={isActive ? 'true' : undefined}
      />
    )}
    align="end"
    side="top"
    items={[
      {
        icon: 'image',
        label: 'Add images',
        onClick: onAddImagesClick,
      },
      {
        icon: 'attachment-2',
        label: 'Attach files',
        onClick: attachFilesDisabled ? undefined : onAttachFilesClick,
        disabled: attachFilesDisabled,
        ...(attachFilesDisabled && attachFilesCaption
          ? { caption: attachFilesCaption, showCaption: true }
          : {}),
      },
    ]}
  />
);
